<sn-action-list
  *ngIf="actions?.length"
  [items]="actions"
  [context]="context"
  alwaysCollapse
></sn-action-list>
<ng-content></ng-content>
